import  fire from 'firebase';
import * as firebase from'firebase/app'



var firebaseConfig = {
    apiKey: "AIzaSyAn1ZYPZV1zp3PNq4j3eDB0Qh66Ldq0OVM",
    authDomain: "digitalproduct-portfolio.firebaseapp.com",
    databaseURL: "https://digitalproduct-portfolio-default-rtdb.firebaseio.com",
    projectId: "digitalproduct-portfolio",
    storageBucket: "digitalproduct-portfolio.appspot.com",
    messagingSenderId: "1054590189585",
    appId: "1:1054590189585:web:e32eb1f141a30fa45431b0"
  };
  // Initialize Firebase
 fire.initializeApp(firebaseConfig); 
//  var db = firebaseApp.firestore();
//  export { db };

const projectStorage = fire.storage();
const projectFirestore =  fire.firestore();
const timestamp = fire.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };
